import { Logo } from "./Logo";
import { Instagram } from "lucide-react";

export const Footer = ({ t }) => (
  <footer data-testid="footer" className="bg-[#2D1810] border-t border-[#D4AF37]/30 py-10">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row md:items-center justify-between gap-10">
      <div className="flex items-start gap-4">
        <Logo className="h-12 w-12" />
        <div>
          <p className="font-serif text-xl font-bold text-[#F5F2EC]">LG · Falegnameria Lomartire</p>
          <p className="mt-2 text-sm text-[#F5F2EC]/60 max-w-sm leading-relaxed">{t.footer.tagline}</p>
        </div>
      </div>
      <div className="flex flex-col gap-4 md:items-end">
        <a
          href="https://www.instagram.com/falegnamerialomartire"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="inline-flex items-center gap-2 text-[#F5F2EC]/80 hover:text-[#D9B36A] transition-colors duration-300 text-sm font-medium"
        >
          <Instagram size={18} />
          {t.footer.follow} — @falegnamerialomartire
        </a>
        <p className="text-xs text-[#F5F2EC]/40">© {new Date().getFullYear()} {t.footer.rights}</p>
      </div>
    </div>
  </footer>
);
